var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper",class:{
    'horizontal-spacing': !_vm.withoutHorizontalSpacing,
    'h-full': _vm.fillHeight,
    'no-top-padding': _vm.noTopPadding,
    'no-bottom-padding': _vm.noBottomPadding,
    'no-left-margin': _vm.withoutLeftMargin,
  }},[(_vm.query)?_c('brand-search-bar',{attrs:{"query":_vm.query,"hide-search":_vm.hideSearch,"hide-pagination":_vm.hidePagination},on:{"select-limit":function($event){return _vm.$emit('select-limit', $event)}}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }